import { configStore } from '@vfde-fe/sails_core';
import app from 'Container/App/index';
import './style.scss';

const store = configStore({});

window.onunload = () => { };

store && app();
